module.exports = __webpack_public_path__ + "static/media/invoice.2dfed750.svg";